import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Asset from "../../../requests/apa/Asset";
import Translator from "../../../requests/apa/Translator";
import Utils, {preloadImage, promiseImageLoad } from "../../../utils/Utils";

class RatingAssetButton extends PureComponent {
  constructor(props) {
        super(props);
        this.state = {
            isFocused: false,
            isClicked: false,
        };
    }

    componentDidMount() {
        this.preloadButtonAssets(this.props.buttonConfig);
    }

    // Función para obtener todas las claves de assets que necesitan ser precargados, incluyendo estados normal, focus, clicked y notclicked
    getAssetKeysForPreload = (buttonConfig) => {
        if (!buttonConfig) return [];

        const collect = (config) => {
        if (!config || typeof config !== "object") return [];

        const keys = [];
        if (config.normal) keys.push(config.normal);
        if (config.focus) keys.push(config.focus);

        if (config.clicked || config.notclicked) {
            return [
            ...keys,
            ...collect(config.clicked),
            ...collect(config.notclicked),
            ];
        }

        return keys;
        };

        return Array.from(new Set(collect(buttonConfig)));
    }

    // Función para precargar los assets necesarios para el botón, utilizando las claves obtenidas de getAssetKeysForPreload
    preloadButtonAssets = (buttonConfig) => {
        const assetKeys = this.getAssetKeysForPreload(buttonConfig);
        if (!assetKeys.length) return;

        const assetUrls = assetKeys
        .map((assetKey) => Asset.get(assetKey))
        .filter(Boolean);

        if (!assetUrls.length) return;
        preloadImage(promiseImageLoad(assetUrls));
    }

    handleFocus = () => {
        this.setState({ isFocused: true });
    }

    handleBlur = () => {
        this.setState({ isFocused: false });
    }

    handleClick = (e) => {
        const { enableClickedState, onClick, isClicked } = this.props;

        // Cuando enableClickedState es true, el botón puede tener un estado de clickeado o no clickeado. Si isClicked es pasado como prop, se usará ese valor para determinar 
        // el estado de clickeado. Si no se pasa isClicked, se alternará el estado interno de isClicked cada vez que se haga clic en el botón.
        if (enableClickedState && typeof isClicked !== "boolean") {
        this.setState({ isClicked: !this.state.isClicked });
        }

        if (typeof onClick === "function") onClick(e);
    }

    //Obtiene la clave del asset dependiendo del estado del botón (normal, focus, clicked)
    getAssetKey = () => {
        const { buttonConfig, isClicked } = this.props;
        const { isFocused, isClicked: internalClicked } = this.state;
        const clickedState = typeof isClicked === "boolean" ? isClicked : internalClicked;

        // Verificar si el buttonConfig tiene estados de clicked o noclicked
        const hasStates = buttonConfig && (buttonConfig.notclicked || buttonConfig.clicked);

        // Determinar la configuración de estado actual (clicked o notclicked)
        const stateConfig = hasStates
        ? (clickedState && buttonConfig.clicked ? buttonConfig.clicked : buttonConfig.notclicked)
        : buttonConfig;

        if (!stateConfig) return "";

        // Retornar el asset correspondiente al estado actual (focus o normal)
        if (isFocused && stateConfig.focus) return stateConfig.focus;
        return stateConfig.normal || "";
    }

    // Obtiene el texto a mostrar dependiendo del estado del botón (clicked o not clicked)
    getText = () =>{
        const {buttonConfig, isClicked} = this.props;
        const {isClicked: internalClicked} = this.state;
        const clickedState = typeof isClicked === "boolean" ? isClicked : internalClicked;
        
        // Verificar si el buttonConfig tiene estados de clicked o noclicked
        const hasStates = buttonConfig && (buttonConfig.notclicked || buttonConfig.clicked);

        // Determinar la configuración de estado actual (clicked o notclicked)
        const stateConfig = hasStates
        ? (clickedState && buttonConfig.clicked ? buttonConfig.clicked : buttonConfig.notclicked)
        : buttonConfig;

        if (!stateConfig) return "";

        if (!stateConfig.textKey) return "";

        const translated = Translator.get(stateConfig.textKey) || "";
        const length = stateConfig.textLength || 0;
        return length ? Utils.cutPlayerString(translated, length) : translated;

    }

    render() {
        const { className, textClassName, alt } = this.props;
        const assetKey = this.getAssetKey();

        return (
        <button
            className={className}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            onClick={this.handleClick}
            onKeyDown={this.props.onKeyDown}
        >
            <img src={Asset.get(assetKey)} alt={alt} />
            <p className={textClassName}>{this.getText()}</p>
        </button>
        );
    }
}

RatingAssetButton.propTypes = {
  className: PropTypes.string,
  buttonConfig: PropTypes.object.isRequired,
  textClassName: PropTypes.string,
  alt: PropTypes.string,
  enableClickedState: PropTypes.bool,
  isClicked: PropTypes.bool,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
};

RatingAssetButton.defaultProps = {
  className: "focusable",
  textClassName: "",
  alt: "",
  enableClickedState: false,
  isClicked: undefined,
  onClick: null,
  onKeyDown: null,
};

export default RatingAssetButton;


// WEBPACK FOOTER //
// ./src/components/Modal/ratingContent/RatingAssetButton.jsx